<template>
    <ChannelLogoCmp v-if="audit.getActorKind() === 'channel' && audit.channel"
        :channel="audit.channel" :size="size" />

    <span v-else class="audit-actor" :title="actor.title">
        <AuditActorTileCmp :kind="audit.getActorKind()" :size="size" />
        <span class="audit-actor-name">{{actor.label}}</span>
    </span>
</template>

<script>
import ChannelLogoCmp from '@/channel/components/ChannelLogoCmp.vue'
import AuditActorTileCmp from '@/audit/components/AuditActorTileCmp.vue'

/**
 * Quem gerou o registro de auditoria: canal, retaguarda ou Muven. Mesmo tile de
 * pedidos e canais, para a coluna "Interação" ser escaneada pela identidade.
 */
export default {
    name: 'AuditActorCmp',
    components: {
        ChannelLogoCmp,
        AuditActorTileCmp,
    },
    props: {
        audit: {
            type: Object,
            required: true,
        },
        subscriber: {
            type: Object,
            default: null,
        },
        size: {
            type: Number,
            default: 20,
        },
    },
    computed: {
        actor() {
            const audit = this.audit
            const kind = audit.getActorKind()

            if (kind === 'channel') {
                // Canal fora da lista (ex.: excluído): sem marca, mas com o nome que houver.
                return {label: audit.channelName || '-', title: null}
            }

            if (kind === 'backend') {
                const backendName = this.subscriber && this.subscriber.getBackendName && this.subscriber.getBackendName()

                return {label: 'Retaguarda', title: backendName ? `Retaguarda: ${backendName}` : null}
            }

            if (kind === 'muven') {
                return {label: 'Muven', title: audit.userEmail ? `Muven: ${audit.userEmail}` : null}
            }

            return {label: 'Canal', title: null}
        },
    },
}
</script>

<style lang="scss" scoped>
.audit-actor {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
    vertical-align: middle;
}

.audit-actor-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
